import React from 'react';
import { useR } from '../router/Router';
import { HomePage } from './HomePage';
import { ScorePage } from './ScorePage';
import { PlatformPage } from './PlatformPage';
import { AboutPage, ContactPage } from './AboutContactPages';
import { 
  UseCasesPage, 
  IntelligencePage, 
  PricingPage, 
  SlidrPage,
  PrivacyPage,
  TermsPage,
  RefundPage,
  BlogPage,
  NewsletterPage,
  ResourcesPage,
  LLMsPage
} from './OtherPages';
import {
  ForFounders,
  ForSales,
  ForPMs,
  ForAccelerators,
  PitchIntel,
  SalesIntel,
  ProductIntel,
  CloseRound,
  CloseDeals,
  WinApproval
} from './PersonaOutcomePages';

export const Routes = () => {
  const { path } = useR();

  // Route mapping
  const routes = {
    '/': HomePage,
    '/score': ScorePage,
    '/platform': PlatformPage,
    '/intelligence': IntelligencePage,
    '/intelligence/pitch': PitchIntel,
    '/intelligence/sales': SalesIntel,
    '/intelligence/product': ProductIntel,
    '/pitch-deck-intelligence': PitchIntel,
    '/sales-deck-intelligence': SalesIntel,
    '/product-deck-intelligence': ProductIntel,
    '/use-cases': UseCasesPage,
    '/for-founders': ForFounders,
    '/for-sales': ForSales,
    '/for-sales-teams': ForSales,
    '/for-pms': ForPMs,
    '/for-product-managers': ForPMs,
    '/for-accelerators': ForAccelerators,
    '/close-round': CloseRound,
    '/close-deals': CloseDeals,
    '/win-approval': WinApproval,
    '/pricing': PricingPage,
    '/slidr': SlidrPage,
    '/about': AboutPage,
    '/contact': ContactPage,
    '/privacy': PrivacyPage,
    '/terms': TermsPage,
    '/refund': RefundPage,
    '/blog': BlogPage,
    '/newsletter': NewsletterPage,
    '/resources': ResourcesPage,
    '/llms': LLMsPage
  };

  const Component = routes[path] || NotFound;

  return <Component />;
};

const NotFound = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '40px' }}>
      <div>
        <h1 style={{ fontSize: '72px', fontWeight: 700, marginBottom: '16px', fontFamily: "'Sansation', sans-serif" }}>
          404
        </h1>
        <p style={{ fontSize: '24px', marginBottom: '32px' }}>
          Page Not Found
        </p>
        <a href="#/" style={{ color: '#0082FB', textDecoration: 'none', fontSize: '18px', fontWeight: 600 }}>
          Go Home
        </a>
      </div>
    </div>
  );
};
